const CustomResourceApplySFSPHZB = () => import('@/views/main/report/customResourceApply/CustomResourceApplySFSPHZB.vue')
export default {
  path: '/main/report/customResourceApplySFSPHZB',
  name: 'customResourceApplySFSPHZB',
  component: CustomResourceApplySFSPHZB,
  children: []
}
